class BerriSplitBannerSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[data-berri-banner-slider]');
    this.slides = this.querySelectorAll('.berri-split-banner__item');
    this.dots = this.querySelectorAll('[data-berri-banner-dot]');
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplaySpeed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.currentIndex = 0;
    this.isPaused = false;

    if (!this.slider || this.slides.length < 2) return;

    this.mobileQuery.addEventListener('change', this.onBreakpointChange.bind(this));
    this.slider.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    this.slider.addEventListener('touchstart', this.pause.bind(this), { passive: true });
    this.slider.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.berriBannerDot, 10);
        this.goToSlide(index);
        this.pause();
        this.isPaused = true;
      });
    });

    this.onBreakpointChange();
  }

  onBreakpointChange() {
    if (this.isMobile()) {
      this.updateDots();
      if (this.autoplayEnabled && !this.isPaused) this.play();
    } else {
      this.pause();
      this.slider.scrollLeft = 0;
      this.currentIndex = 0;
      this.updateDots();
    }
  }

  onTouchEnd() {
    if (!this.isMobile() || !this.autoplayEnabled) return;
    window.setTimeout(() => {
      this.isPaused = false;
      this.play();
    }, 3000);
  }

  isMobile() {
    return this.mobileQuery.matches;
  }

  onScroll() {
    if (!this.isMobile()) return;
    const index = Math.round(this.slider.scrollLeft / this.slider.clientWidth);
    if (index !== this.currentIndex) {
      this.currentIndex = index;
      this.updateDots();
    }
  }

  updateDots() {
    this.dots.forEach((dot, index) => {
      const isActive = index === this.currentIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  play() {
    if (!this.isMobile() || !this.autoplayEnabled || this.isPaused) return;
    this.pause();
    this.autoplayTimer = window.setInterval(() => this.next(), this.autoplaySpeed);
  }

  pause() {
    window.clearInterval(this.autoplayTimer);
  }

  next() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.goToSlide(nextIndex);
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.slider.scrollTo({
      left: index * this.slider.clientWidth,
      behavior: 'smooth',
    });
    this.updateDots();
  }
}

customElements.define('berri-split-banner-slider', BerriSplitBannerSlider);
